import { SEO } from "./seo";

export class HomePage {
    id?: string;
    jsonContent?: string

 
}